import React from "react";
import LayoutStoreHome from "../../layouts/LayoutStoreHome";
import CheckoutForm from "../../components/Forms/CheckoutForm";

const StoreCheckout = () => {
  return (
    <LayoutStoreHome>
      <CheckoutForm />
    </LayoutStoreHome>
  );
};

export default StoreCheckout;
